export { default } from "./DialogContent";
